<template>
	<div class="animate_animated animate__slideInRight">
		<div class="fixed inset-x-0 top-0 z-20">
		<div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
       <div class="h-1 bg-gradient-to-r from-[#62EC14] to-[#88fa46]"></div>
			<div class="flex items-center px-4 py-4 ">
				<div class="flex items-center w-full gap-4">
					<a  @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
					<span class="text-base text-content font-medium ">Search Property</span>
				</div>
			</div>
		</div>
    </div>
    <div class="pt-20 mt-2 bg-white">
    <div class="bg-white min-h-screen p-4">
      <form>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Owner</label>
          <input type="text" v-model="search.owner" placeholder="Owner Name" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-10">
          <label for="" class="text-main text-opacity-50 text-sm block mb-5 ">Property For</label>
          <div class="flex">
            <span class="radio-selection">
              <input type="radio" v-model="search.property_for"  value="Sale" name="propertyFor" id="sale" class="hidden">
              <label for="sale" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills mr-3"> Sale </label>
            </span>
             <span class="radio-selection">
              <input type="radio" v-model="search.property_for" value="Rental" name="propertyFor" id="rent" class="hidden">
              <label for="rent" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills"> Rental </label>
            </span>
          </div>
        </div>
         <div class="mb-10">
          <label for="" class="text-main text-opacity-50 text-sm block mb-5 ">Property From</label>
          <div class="flex">
            <span class="radio-selection">
              <input type="radio" v-model="search.property_from" name="propertyFrom" value="Owner" id="owner" class="hidden">
              <label for="owner" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills mr-3"> Owner </label>
            </span>
             <span class="radio-selection">
              <input type="radio" v-model="search.property_from" name="propertyFrom" value="Developer" id="developer" class="hidden">
              <label for="developer" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills"> Developer </label>
            </span>
          </div>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Project/Location</label>
          <input type="text" v-model="search.project_name " placeholder="Project/Location" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
          <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Building/Plot</label>
          <input type="text" v-model="search.building" placeholder="Building/Plot Name" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Select Projects</label>
          <multiselect v-model="search.project_ids" :searchable="true"  placeholder="Select Projects" label="name" valueProp="id" :options="projectList" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Configuration</label>
          <select v-model="search.configuration_id" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select Configuration</option>
           <option
              v-for="(c, key) in propertyKeysList.configuration"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Building Type *</label>
          <select v-model="search.building_type" required class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select the type</option>
            <option
              v-for="(bt, key) in propertyKeysList.building_types"
              :key="key"
              :value="bt"
            >{{bt}}</option>
          </select>
        </div>
         <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Type</label>
          <select v-model="search.property_type_id" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select the type</option>
            <option
              v-for="(pt, key) in propertyType"
              :key="key"
              :value="pt"
            >{{pt}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Land Type</label>
          <select v-model="search.land_type" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select Land Type</option>
            <option
              v-for="(c, key) in propertyKeysList.land_types"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>

        <div class="mb-6 relative" v-if="showLeaseTypeField">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Lease Type</label>
          <select v-model="search.lease_type" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select Lease Type</option>
            <option
              v-for="(c, key) in propertyKeysList.lease_types"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Zone</label>
          <select v-model="search.zone" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select Zone</option>
           <option
              v-for="(c, key) in propertyKeysList.zones"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Propsal For</label>
          <select v-model="search.proposal_for" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select Propsal For</option>
           <option
              v-for="(c, key) in propertyKeysList.proposal_fors"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Status</label>
        <select v-model="search.status" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select</option>
          <option
            v-for="(s, key) in propertyKeysList.property_statuses"
            :key="key"
            :value="s.id"
          >{{s.name}}</option>
        </select>
      </div>
        <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Possession Status</label>
        <select v-model="search.posession_status" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select</option>
          <option
            v-for="(c, key) in propertyKeysList.posesstion_status"
            :key="key"
            :value="c"
          >{{c}}</option>
        </select>
      </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">City</label>
          <select v-model="search.city_ids" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
            <option selected disabled>Select City</option>
            <option
              v-for="(r, key) in leadKeysList.cities"
              :key="key"
              :value="r.id"
            >{{r.name}}</option>
          </select>
        </div>
         <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Locality</label>
          <multiselect v-model="search.locality_ids" :searchable="true"  :options-limit="leadKeysList.locality.length" placeholder="Select Locality" label="name" valueProp="id" :options="leadKeysList.locality" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mt-10">
          <a @click="clearFilters" class="clearFilter"> Clear Filters</a>
          <button type="button" @click="performSearch" class="bg-primary text-base font-semibold text-white rounded-xl p-5 w-full disabled:opacity-50" >Filter</button>
        </div>
      </form>
    </div>
  </div>
	</div>
</template>
<script>
import Multiselect from '@vueform/multiselect'
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      showLeaseTypeField: false,
      search: {
        owner: null,
        property_for: null,
        property_from: null,
        project_name: null,
        building: null,
        configuration_id: null,
        property_type_id: null,
        city_ids: null,
        posession_status: null,
        status: null,
        project_ids: [],
        locality_ids: [],
      },
    }
  },
  methods: {
    toggleLeaseTypeField() {
      this.showLeaseTypeField = this.search.land_type === 'Lease Hold';
    },
    performSearch(){
      this.$store.dispatch('setAdvSParams', this.search);
      this.$router.push({name: 'Properties'})
    },
    seedDefaults(){
      this.search = this.advSParams
    },
    clearFilters(){
      this.search = {
        owner: null,
        property_for: null,
        property_from: null,
        project_name: null,
        building: null,
        configuration_id: null,
        property_type_id: null,
        posession_status: null,
        status: null,
        city_ids: null,
        project_ids: [],
        locality_ids: [],
      }
      this.$store.dispatch('setAdvSParams', {});
    }
  },
  created(){
    if(Object.keys(this.advSParams).length > 0){
      this.seedDefaults();
    }
  },
  computed: {
    propertyType() {
      if (this.search.building_type === 'Residential') {
        return this.propertyKeysList.residential_property_type
      } else if (this.search.building_type === 'Commercial') {
        return this.propertyKeysList.commercial_property_type
      } else if (this.search.building_type === 'Plot') {
        return this.propertyKeysList.plot_property_type
      } else {
        return []
      }
    },
    propertyKeysList(){
      return this.$store.getters.propertyKeys;
    },
    projectList(){
      return this.$store.getters.projectMaster;
    },
    advSParams(){
      return this.$store.getters.advSParams;
    },
    leadKeysList(){
      return this.$store.getters.leadKeys;
    },
  },
  watch: {
    'search.land_type': function(newVal) {
      this.showLeaseTypeField = newVal === 'Lease Hold';
      if (newVal !== 'Lease Hold') {
        this.search.lease_type = null;
      }
    }
  }
}
</script>
<style scoped>
.clearFilter{
  display: table;
  margin:20px auto;
  opacity: .5;
  font-size: 14px;
}
</style>